import { ArticleParagraph1, ArticleParagraph2, useDeviceType, Image } from '@cian/ui-kit';
import * as style from './SliderItem.css';
import { clsx } from 'clsx';
import { openArticle } from '../tracking';

interface ISliderItemProps {
  title: string;
  notice: string;
  image: string;
  link: string;
  caCategory: string;
}

export const SliderItem: React.FC<ISliderItemProps> = ({ title, notice, image, link, caCategory }) => {
  const device = useDeviceType();

  return (
    <a
      href={link}
      onClick={() => openArticle(title, link, caCategory)}
      className={style['link']}
      target="_blank"
      rel="noreferrer"
    >
      <div className={clsx(style['container'], device === 'phone' && style['container-phone'])}>
        <div className={style['image']}>
          <Image
            preloader
            alt={title}
            objectFit="contain"
            src={`https://static.cdn-cian.ru/frontend/info-assets/sob-guide/${image}`}
          />
        </div>
        <div className={style['title']}>
          <ArticleParagraph1 fontWeight="400">{title}</ArticleParagraph1>
        </div>
        <div className={style['notice']}>
          <ArticleParagraph2 color="icon-secondary-default" fontWeight="400">
            {notice}
          </ArticleParagraph2>
        </div>
      </div>
    </a>
  );
};
